import { Button } from 'antd';
import styled from 'styled-components';

export const AlternativeButton = styled(Button)`
  border: none;
  height: unset;
  line-height: unset;
  margin: 0;
  padding-inline: 0.75em;
  padding: 0;
  color: inherit;
`;
